import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import parsePhoneNumber from "libphonenumber-js";
import { sendOtpToMobile } from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import { APP_CONST } from "../../../config/const";
import { useSelector } from "react-redux";
import { Toaster } from "../../../utils/toaster";
import PhoneInput from "react-phone-input-2";

import CloseModal from "../../../assets/images/icons/toggle-close.svg";
import ChevronRight from "../../../assets/images/icons/chevron-down.svg";

const MobileNumberModal = ({ show, handleClose, handleModalShow }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const isOtpRequired = useSelector(
    (state) => state?.app?.appDetails?.OTP === 0
  );
  const dispatch = useDispatch();

  const handleSubmit = () => {
    setIsSubmitting(true);
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    if (phoneNumber) {
      payload.mobile = phoneNumber.nationalNumber;
      payload.country_code = phoneNumber.countryCallingCode;
    }

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        setIsSubmitting(false);
        if (res?.data?.error === false) {
          persistDetails(payload);
          handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.AUTO);
          handleModalShow(
            isOtpRequired
              ? APP_CONST.AUTH_MODAL.VERIFY_NUMBER
              : APP_CONST.AUTH_MODAL.REGISTER
          );
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  const persistDetails = (data) => {
    localStorage.setItem("mobile_details", JSON.stringify(data));
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal register"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      >
        <img src={CloseModal} alt="close modal" />
      </button>

      <Modal.Body>
        <div className="login-section">
          <Modal.Title>Sign up</Modal.Title>

          <div className="form-steps">
            <Form>
              <Form.Group className="form-group" controlId="formBasicPassword">
                <Form.Label>Phone numbe</Form.Label>
                <PhoneInput
                  country={"in"}
                  inputProps={{
                    name: "phone",
                    required: true,
                  }}
                  onlyCountries={["in"]}
                  inputStyle={{
                    width: "100%",
                    padding: "0.7rem 0.75rem",
                    paddingLeft: "50px",
                  }}
                  onChange={(phone) => {
                    setMobileNumber(phone);
                  }}
                />
              </Form.Group>
              <div className="modal-btn">
                <Button
                  variant="primary"
                  className="signup"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Send OTP"}
                </Button>
              </div>
            </Form>

            <div className="lgn-sgnup-ac">
              <span>Already have an account?</span>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  handleClose(APP_CONST.AUTH_MODAL.MOBILE_NUMBER);
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
              >
                Login now
                <img src={ChevronRight} alt="chevron right" />
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default MobileNumberModal;
